import React from 'react'
import HourReportTabel from '../../../../components/EOL-Checker/Report/Eolc_HourReport/HourReportTabel'
import { Divider, Typography } from 'antd'

const Eolc_HourReport = () => {
    return (
        <>
        {/* <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Hourly Report
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} /> */}

            <HourReportTabel />
        </>
    )
}

export default Eolc_HourReport